










































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { Paciente } from '../../../../back/src/entity/Paciente';

import Carregando from '../../components/Carregando.vue';
import TheConsultasDadosIndividual from '../../components/consultas/TheConsultasDadosIndividual.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';

export default Vue.extend({
  name: 'ConsultasAtender',
  components: {
    Carregando,
    TheConsultasDadosIndividual,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
  },
  data() {
    return {
      loading: {
        consulta: true,
        paciente: true,
      },
      consulta: null,
      paciente: null,
    };
  },
  computed: {
    consultaId(): number {
      return Number(this.$route.params.consultaId);
    },
  },
  async mounted() {
    await this.getConsulta();
    await this.getPaciente();
  },
  methods: {
    async getConsulta() {
      this.loading.consulta = true;
      try {
        const response = await Requester.consulta.consulta(this.consultaId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.consulta = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.consulta = false;
      }
    },
    async getPaciente() {
      this.loading.paciente = true;
      try {
        const response = await Requester.paciente.paciente(this.consulta.paciente_id);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'PacientesIndex' });
        } else {
          this.paciente = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.paciente = false;
      }
    },
  },
});
